/**
 * 视频设置面板和顶栏用的线性图标，和 App 同一套（源文件 drama-ui-app/icons/*.svg，改那边要同步这里）。
 * 照红果的样式和含义自己画的：24 的画布、1.8 粗、圆头圆角，颜色跟着文字走（currentColor）。
 */
function svgProps(size: number) {
  return {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
  }
}

export function SpeedIcon({ size = 24 }: { size?: number }) {
  return (
    <svg {...svgProps(size)}>
      <path d="M12 4A8 8 0 1 1 6.34 6.34" />
      <path d="M12 4V7.5" />
      <path d="M9.8 14.2L15 9" />
    </svg>
  )
}

export function QualityIcon({ size = 24 }: { size?: number }) {
  return (
    <svg {...svgProps(size)}>
      <path d="M6 5H18A3 3 0 0 1 21 8V16A3 3 0 0 1 18 19H6A3 3 0 0 1 3 16V8A3 3 0 0 1 6 5Z" />
      <path d="M7.5 9.5V14.5" />
      <path d="M7.5 12H10.5" />
      <path d="M10.5 9.5V14.5" />
      <path d="M13.5 9.5V14.5H14.75A2.5 2.5 0 0 0 14.75 9.5Z" />
    </svg>
  )
}

export function CleanEnterIcon({ size = 24 }: { size?: number }) {
  return (
    <svg {...svgProps(size)}>
      <path d="M6 3.5H18A2.5 2.5 0 0 1 20.5 6V18A2.5 2.5 0 0 1 18 20.5H6A2.5 2.5 0 0 1 3.5 18V6A2.5 2.5 0 0 1 6 3.5Z" />
      <path d="M13 8H16V11" />
      <path d="M8 13V16H11" />
    </svg>
  )
}

export function CleanExitIcon({ size = 24 }: { size?: number }) {
  return (
    <svg {...svgProps(size)}>
      <path d="M6 3.5H18A2.5 2.5 0 0 1 20.5 6V18A2.5 2.5 0 0 1 18 20.5H6A2.5 2.5 0 0 1 3.5 18V6A2.5 2.5 0 0 1 6 3.5Z" />
      <path d="M13.5 7V10.5H17" />
      <path d="M7 13.5H10.5V17" />
    </svg>
  )
}

/** 长按顶速时视频底部那个小胶囊的四个图标：上滑锁定、下滑退出的双箭头，锁上 / 打开的锁 */
export function DoubleUpIcon({ size = 24 }: { size?: number }) {
  return (
    <svg {...svgProps(size)}>
      <path d="M7 12.5L12 7.5L17 12.5" />
      <path d="M7 17L12 12L17 17" />
    </svg>
  )
}

export function DoubleDownIcon({ size = 24 }: { size?: number }) {
  return (
    <svg {...svgProps(size)}>
      <path d="M7 7L12 12L17 7" />
      <path d="M7 11.5L12 16.5L17 11.5" />
    </svg>
  )
}

const LOCK_BODY = 'M6.5 10.5H17.5A1.5 1.5 0 0 1 19 12V18.5A1.5 1.5 0 0 1 17.5 20H6.5A1.5 1.5 0 0 1 5 18.5V12A1.5 1.5 0 0 1 6.5 10.5Z'

export function LockIcon({ size = 24 }: { size?: number }) {
  return (
    <svg {...svgProps(size)}>
      <path d={LOCK_BODY} />
      <path d="M12 14.5V16" />
      <path d="M8 10.5V8A4 4 0 0 1 16 8V10.5" />
    </svg>
  )
}

export function UnlockIcon({ size = 24 }: { size?: number }) {
  return (
    <svg {...svgProps(size)}>
      <path d={LOCK_BODY} />
      <path d="M12 14.5V16" />
      <path d="M8 10.5V8A4 4 0 0 1 15.7 6.5" />
    </svg>
  )
}

export function ChevronIcon({ size = 24 }: { size?: number }) {
  return (
    <svg {...svgProps(size)}>
      <path d="M9.5 6.5L15 12L9.5 17.5" />
    </svg>
  )
}

/**
 * 长按快进时黑条左边的动画，照红果 video_speed_2x_v2：32 见方里三个白色向右的圆角三角，
 * 从左到右依次亮起再暗下，1.17 秒一轮（动画在 global.css 的 .ff-chase）。和 App 的 FastForwardChase 一样。
 */
export function FastForwardChase() {
  return (
    <svg className="ff-chase" width="32" height="32" viewBox="0 0 32 32" aria-hidden>
      {[5, 14, 23].map((x) => (
        <path
          key={x}
          d={`M${x} 11L${x + 8} 16L${x} 21Z`}
          fill="#fff"
          stroke="#fff"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  )
}
